import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Icon,
  IconButton,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
  Switch,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CreateIcon from "@material-ui/icons/Create";
import SettingsIcon from "@material-ui/icons/Settings";
import DeleteIcon from "@material-ui/icons/Delete";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";

import { EQUIPMENT } from "../../configs/urls";
import { getApi, deleteApi, putApi } from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
}));

export default function Equipments() {
  const classes = useStyles();
  const [equipments, setEquipmentsList] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const [params, setParams] = useState({ page: 0 });
  const [userRole, setUserRole] = useState();

  // const [totalEquipmentsCount, setTotalEquipmentsCount] = useState(0)

  useEffect(() => {
    fetchEquipments(true);
  }, []); //eslint-disable-line

  const fetchEquipments = (isInitialLoad) => {
    setIsRequesting(true);

    getApi(EQUIPMENT, params)
      .then(
        (res) => {
          // if (isInitialLoad) setTotalEquipmentsCount(res.meta.total);

          const data = res.data || [];
          const newList = [...equipments, ...data];
          setEquipmentsList(newList);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const deleteEquipment = (id, idx) => {
    setIsRequesting(true);
    deleteApi(EQUIPMENT + "/" + id)
      .then(
        (res) => {
          let equipmentData = equipments;
          equipmentData.splice(idx, 1);
          setEquipmentsList(equipmentData);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const loadMoreEquipment = () => {
    setParams({ ...params, page: (params.page += 1) });
    fetchEquipments();
  };

  const handleStatusChange = (equipment, idx) => {
    setIsRequesting(true);
    const params = {
      id: equipment.id,
      active: equipment.active == 1 ? 0 : 1,
    };
    putApi(EQUIPMENT, params)
      .then(
        () => {
          let list = [...equipments];
          list[idx].active = params.active;
          setEquipmentsList(list);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const renderEquipments = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Product number</TableCell>
            <TableCell>Unique number</TableCell>
            <TableCell>Brand Name</TableCell>
            <TableCell>Year</TableCell>
            <TableCell>Ownership</TableCell>
            <TableCell>Owner Name</TableCell>
            <TableCell>Hours</TableCell>
            <TableCell>Warranty</TableCell>
            <TableCell>Warranty Start Date</TableCell>
            <TableCell>Warranty Start Date</TableCell>

            <TableCell>Status</TableCell>
            <TableCell align="center">Active</TableCell>
            <TableCell align="right">Edit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {equipments.map((equipment, idx) => (
            <TableRow key={idx}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>
                {equipment.type ? equipment.type.name : "--"}
              </TableCell>
              <TableCell>{equipment.product_name || "--"}</TableCell>
              <TableCell>{equipment.product_no || "--"}</TableCell>
              <TableCell>{equipment.unique_number || "--"}</TableCell>
              <TableCell>{equipment.make || "--"}</TableCell>
              <TableCell>{equipment.year || "--"}</TableCell>
              <TableCell>{equipment.ownership || "--"}</TableCell>
              <TableCell>{equipment.owner_name || "--"}</TableCell>
              <TableCell>{equipment.hours || "--"}</TableCell>
              <TableCell>{equipment.warrent_status || "--"}</TableCell>
              <TableCell>{equipment.warrent_start_date || "--"}</TableCell>
              <TableCell>{equipment.warrent_end_date || "--"}</TableCell>

              <TableCell>{equipment.status || "--"}</TableCell>
              <TableCell align="center">
                <Switch
                  checked={equipment.active == 1}
                  onChange={() => {
                    handleStatusChange(equipment, idx);
                  }}
                  color="primary"
                  name="checkedB"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              </TableCell>
              <TableCell align="right">
                <Link to={"/admin/equipments/operations/" + equipment.id}>
                  <IconButton edge="end" aria-label="edit">
                    <CreateIcon />
                  </IconButton>
                </Link>
                {/* <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => deleteEquipment(equipment.id, idx)}
                >
                  <DeleteIcon />
                </IconButton> */}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/*
        equipments.length < totalUsersCount &&
        <Grid container justify="center" style={{ padding: 20 }}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={() => loadMoreUsers()}
          >
            Load More
          </Button>
        </Grid>
      }*/}
    </TableContainer>
  );

  useEffect(() => {
    const dataNew = localStorage?.getItem("user");
    setUserRole(JSON.parse(dataNew)?.role?.id);
  }, []);

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Equipments
            </Typography>
            {userRole !== 3 && (
              <div>
                <Link to="/admin/equipments/operations">
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    endIcon={<Icon>add_circle</Icon>}
                  >
                    Add Equipment
                  </Button>
                </Link>
                <Link to="/admin/equipments/manage">
                  <Button
                    variant="contained"
                    color="primary"
                    className={(classes.button, classes.marginLeft)}
                    endIcon={<SettingsIcon />}
                  >
                    Manage Equipment Types
                  </Button>
                </Link>
              </div>
            )}
          </Grid>
          {equipments.length ? (
            renderEquipments()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Equipment Found
            </Box>
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}
